// src/App.js
import React from "react";
import "./App.css";
import Home from "./Components/Home";
import Services from "./Components/Services";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Navbar from "./Components/NavBar";
import Resources from "./Components/Resources";
import Blogs from "./Components/Blogs";
import NewBlogPost from "./Components/NewBlogPost";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./Components/Login";
import Register from "./Components/Register";
import AdminUpload from "./Components/AdminUpload";
import Newsletter from "./Components/Newsletter";
import PrivateRoute from "./Components/PrivateRoute";
import NewNewsletter from "./Components/NewNewsletter";
import Dictionary from "./Components/Dictionary";
import MentalHealthGame from "./Components/MentalHealthGame";
import ResetPassword from "./Components/ResetPassword";

function App() {
	return (
		<AuthProvider>
			<Router>
				<div className="App">
					<Navbar />
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/services" element={<Services />} />
						<Route path="/about" element={<About />} />
						<Route path="/contact" element={<Contact />} />
						<Route path="/resources" element={<Resources />} />
						<Route path="/blog" element={<Blogs />} />
						<Route path="/newsletter" element={<Newsletter />} />
						<Route
							path="/new-newsletter"
							element={
								<PrivateRoute adminOnly={true}>
									<NewNewsletter />
								</PrivateRoute>
							}
						/>
						<Route path="/login" element={<Login />} />
						<Route path="/signup" element={<Register />} />
						<Route
							path="/new-blog"
							element={
								<PrivateRoute adminOnly={true}>
									<NewBlogPost />
								</PrivateRoute>
							}
						/>
						<Route
							path="/admin/upload"
							element={
								<PrivateRoute adminOnly={true}>
									<AdminUpload />
								</PrivateRoute>
							}
						/>
						<Route path="/dictionary" element={<Dictionary />} />
						<Route path="/mental-health-game" element={<MentalHealthGame />} />
						<Route path="/reset-password" element={<ResetPassword />} />
					</Routes>
				</div>
			</Router>
		</AuthProvider>
	);
}

export default App;
